import React from 'react';
import { Bell, BellOff } from 'lucide-react';
import { Button } from './Button';
import { useNotifications } from '@/hooks/useNotifications';

/**
 * Componente para configurar notificaciones de disponibilidad
 */
export const NotificationSettings: React.FC = () => {
  const { 
    notificationsEnabled, 
    hasPermission, 
    activarNotificaciones, 
    desactivarNotificaciones, 
    solicitarPermisos 
  } = useNotifications();

  const handleToggleNotifications = async () => {
    if (!hasPermission) {
      const granted = await solicitarPermisos();
      if (granted) {
        await activarNotificaciones();
      }
    } else if (notificationsEnabled) {
      desactivarNotificaciones();
    } else {
      await activarNotificaciones();
    }
  };

  return (
    <div className="bg-secondary-800 rounded-lg p-4 border border-secondary-700">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {notificationsEnabled ? (
            <Bell className="h-5 w-5 text-primary-400" />
          ) : (
            <BellOff className="h-5 w-5 text-secondary-400" />
          )}
          <div>
            <h3 className="text-secondary-50 font-medium">
              Recordatorios de Disponibilidad
            </h3>
            <p className="text-secondary-400 text-sm">
              Lun-Jue a las 10:00, 15:00 y 20:30
            </p>
          </div>
        </div>
        
        <Button
          onClick={handleToggleNotifications}
          variant={notificationsEnabled ? "secondary" : "primary"}
          size="sm"
        >
          {notificationsEnabled ? 'Desactivar' : 'Activar'}
        </Button>
      </div>
      
      {!hasPermission && (
        <div className="mt-3 p-3 bg-yellow-500/10 border border-yellow-500/20 rounded-lg">
          <p className="text-yellow-200 text-sm">
            💡 Permite las notificaciones para recibir recordatorios automáticos
          </p>
        </div>
      )}
    </div>
  );
};